<template>
  <div class="newsdetail">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a :href="'/#/'">
            <i class="fa fa-home"></i>Home
          </a>
        </li>
        <li class="breadcrumb-item">
          <a :href="'/#/newslist/'+this.listName">{{listName}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{newsTitle}}</li>
      </ol>
    </nav>
    <div class="card news-detail">
      <div class="card-header">
        <div class="card-title">
          <span v-html="newsTitle"></span>
          <div class="text-sm mt-10 text-muted"><span v-html="newsCreated"></span></div>
        </div>
      </div>
      <div class="card-body">
        <span v-html="newsDetail"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsDetail',
  data: () => ({
    newsTitle: '',
    newsCreated: '',
    newsDetail: '',
    site: '',
    listName: ''
  }),
  created () {
    this.listName = this.$route.params.name
    if (this.listName === 'NewsClip') {
      this.site = this.GLOBAL.sharepoint['eipsite_id']
    } else {
      this.site = this.GLOBAL.sharepoint['pilotportalsite_id']
    }
    this.getDetail(localStorage.getItem('access_token'), this.site, this.listName, this.$route.params.id)
      .then(resp => {
        this.newsTitle = resp.data.fields.Title
        this.newsCreated = this.$moment(resp.data.fields.Created).format('YYYY-MM-DD HH:mm:ss')
        this.newsDetail = resp.data.fields.Body.replace(new RegExp('"/sites/CrewPortal', 'g'), '"https://starluxairlines.sharepoint.com/sites/CrewPortal')
      })
      .catch(err => {
        console.log('err', err)
      })
  }
}
</script>
